module.exports = __webpack_public_path__ + "img/12.6883389f.png";